import React from "react";
import { MenuItem } from "@shared/interfaces";

import SidebarItem from "../SidebarItem/SidebarItem";

import "./index.scss";

interface SidebarItemsProps {
  items: MenuItem[];
  className: string | undefined;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const SidebarItems = (props: SidebarItemsProps) => {
  const { items, className, setCollapsed, collapsed } = props;
  return (
    <>
      {items.map((item) => (
        <SidebarItem
          key={item.key ?? item.name}
          setCollapsed={setCollapsed}
          collapsed={collapsed}
          item={item}
          className={className}
        />
      ))}
    </>
  );
};

export default SidebarItems;
